import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../../services/spinner.service';
import { ApiBaseAttribute, ApiSetReservationFacilityAttributesRequest } from '../../../api-client-module';
import { ProjectLanguage } from '../../../firestore-models/project-language';

import { ConfigurationService } from '../../../configuration.service';
import { ApiClientService } from '../../../api-client.service';
import { AppConst } from '../../../app-const';
import { MultiNameDialogComponent } from '../../../common/multi-name-dialog/multi-name-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface ReservationFacilityAttributeDialogData {
  change_type: number;
  reservationFacilityAttribute?: ApiBaseAttribute;
}

@Component({
  selector: 'app-reservation-facility-attribute-dialog',
  templateUrl: './reservation-facility-attribute-dialog.component.html',
  styleUrls: ['./reservation-facility-attribute-dialog.component.css'],
  standalone: false,
})
export class ReservationFacilityAttributeDialogComponent implements OnInit {

  projectId: string;
  //展示属性情報
  reservationFacilityAttribute?: ApiBaseAttribute;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //展示属性情報フォーム
  reservationFacilityAttributeFormGroup!: FormGroup;
  reservationFacilityAttributeIdControl!: FormControl;
  reservationFacilityAttributeNameControl!: FormControl;

  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<ReservationFacilityAttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReservationFacilityAttributeDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.reservationFacilityAttribute = this.data.reservationFacilityAttribute;
    if (!this.reservationFacilityAttribute) {
      this.reservationFacilityAttribute = {
        attribute_id: '',
        attribute_names: [],
        project_id: this.projectId,
        enabled: true
      };
      this.isAdded = true;
    }
    this.createForm();
    this.reservationFacilityAttributeIdControl = this.reservationFacilityAttributeFormGroup.get('reservationFacilityAttributeId') as FormControl;
    this.reservationFacilityAttributeNameControl = this.reservationFacilityAttributeFormGroup.get('reservationFacilityAttributeName') as FormControl;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToReservationFacilityAttributeId() {
    return this.reservationFacilityAttributeIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.reservationFacilityAttributeIdControl.hasError('pattern')
        ? this.translate.instant('半角数字')
        : '';
  }

  public getErrorMessageToReservationFacilityAttributeName() {
    return this.reservationFacilityAttributeNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.reservationFacilityAttributeFormGroup = this.formBuilder.group(
      {
        reservationFacilityAttributeId: [this.reservationFacilityAttribute!.attribute_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
        reservationFacilityAttributeName: [this.reservationFacilityAttribute!.attribute_names, [Validators.required]]
      }
    );
  }

  //更新ボタン
  addReservationFacilityAttribute(): void {
    if (this.reservationFacilityAttributeFormGroup.valid) {
      this.reservationFacilityAttribute!.attribute_id = this.reservationFacilityAttributeIdControl.value;
      this.reservationFacilityAttribute!.attribute_names = this.reservationFacilityAttributeNameControl.value;
      if (this.reservationFacilityAttribute) {
        let request: ApiSetReservationFacilityAttributesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          attributes: [this.reservationFacilityAttribute]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setReservationFacilityAttributes(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //属性名称ダイアログ
  openAttributeNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.reservationFacilityAttribute!.attribute_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacilityAttribute!.attribute_names = result;
        this.reservationFacilityAttributeNameControl.setValue(this.reservationFacilityAttribute!.attribute_names);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
